import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3417">
      <Navbar data-id="element-3418" />
      <main data-id="element-3419">
        <ConsularAffairs data-id="element-3420" />
      </main>
      <Footer data-id="element-3421" />
      <FeedbackPopup data-id="element-3422" />
    </div>;
}